import React from "react"
import tw, { styled } from "twin.macro"

const DesktopTabsContainer = styled.div`
  ${tw`hidden sm:block flex`}
`

const Tab = styled.button`
  ${tw`px-3 py-2 font-medium text-sm leading-5 rounded-md text-gray-500 hover:text-gray-700 focus:outline-none focus:text-gray-700 focus:bg-gray-100`}
  ${props => props.active && tw`bg-gray-200`}
`

export const TabsContext = React.createContext({ activeTab: 0 })

const Tabs = ({ elements, children }) => {
  const [currentIndex, setCurrentIndex] = React.useState(0)
  return (
    <TabsContext.Provider value={{activeTab: currentIndex}}>
      <div>
        <DesktopTabsContainer>
          {elements.map((element, index) => (
            <Tab key={index} active={index === currentIndex} onClick={() => setCurrentIndex(index)}>{element}</Tab>
          ))}
        </DesktopTabsContainer>
      </div>
      <div>{children}</div>
    </TabsContext.Provider>
  )
}

export default Tabs
